import React from "react";
import { Card } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import { defaultImageUrl } from "../../config_and_helpers/config";
import "./ProductComponentStyle.css";
import S3MediaImage from "../Generic/S3MediaImage";
import S3MediaLink from "../Generic/S3MediaLink";

/**
 * Component for displaying a similar product object.
 *
 * @param {Object} SimilarProductObjectComponent - The similar product object component.
 * @param {string} SimilarProductObjectComponent.name - The name of the product.
 * @param {string} SimilarProductObjectComponent.catNum - The category number of the product.
 * @param {number} SimilarProductObjectComponent.index - The index of the product.
 * @param {Function} SimilarProductObjectComponent.onDelete - The function to call when the product is deleted.
 * @param {string} SimilarProductObjectComponent.image_url - The URL of the product image.
 * @returns {JSX.Element} The similar product object component.
 */
const SimilarProductObjectComponent = ({
  name,
  catNum,
  index,
  onDelete,
  image_url,
}) => {
  return (
    <Card className="d-flex flex-row align-items-center mb-3 p-2 similar-product-card">
      {image_url ? (
        <S3MediaLink url={image_url} title="Open product image">
          <S3MediaImage
            url={image_url}
            fallbackUrl={defaultImageUrl}
            style={{ width: "100px", height: "100px", objectFit: "contain" }}
            alt={name}
          />
        </S3MediaLink>
      ) : (
        <Card.Img
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
          src={defaultImageUrl}
          alt={name}
        />
      )}
      <div className="ms-3 flex-grow-1">
        <Card.Body className="p-0">
          <Card.Title className="mb-1">{name}</Card.Title>
          <Card.Text className="mb-1">{catNum}</Card.Text>
        </Card.Body>
      </div>
      <X
        width={24}
        height={24}
        onClick={() => onDelete(index)}
        style={{ cursor: "pointer", minWidth: "24px", minHeight: "24px" }}
      />
    </Card>
  );
};

export default SimilarProductObjectComponent;
